import type { Overline } from '@time-line/components/types';
import type { JunipProductOverview } from 'types/reviews';

export const addReviewsToOverline = (
  overline: Overline,
  junipProductOverview?: JunipProductOverview,
  options?: { includeRecommendedPercentage?: boolean },
): Overline => {
  if (
    overline.type !== 'reviews' ||
    !junipProductOverview ||
    typeof junipProductOverview.ratingCount !== 'number' ||
    typeof junipProductOverview.ratingAverage !== 'number'
  ) {
    return overline;
  }

  const { ratingCount, ratingAverage, recommendedPercentage } =
    junipProductOverview;

  return {
    ...overline,
    reviewsOverview: {
      ratingCount,
      ratingAverage,
      ...(options?.includeRecommendedPercentage &&
        typeof recommendedPercentage === 'number' && { recommendedPercentage }),
    },
  };
};
